import { metaContent } from './utils'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

const buildUrl = (path: string, query?: { [key: string]: string }): string => {
  const abn = metaContent('_fm_abn')
  let qstr = ''
  if (typeof query !== 'undefined') {
    qstr = '?' + (new URLSearchParams(query).toString())
  }
  if (!abn) {
    return `/so/hospital${path}${qstr}`
  } else {
    return `/so/hospital/${abn}${path}${qstr}`
  }
}

const configWithCsrf = (inConfig?: AxiosRequestConfig): AxiosRequestConfig => {
  const config = inConfig ? {...inConfig} : {}
  if (!config.headers) {
    config.headers = {}
  }
  config.headers['X-CSRF-Token'] = metaContent('csrf-token')
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  config.headers['Content-Type'] = 'application/json'
  config.withCredentials = true
  return config
}

const post =
  <T = any, R = AxiosResponse<T>>
  (url: string, data?: any, config?: AxiosRequestConfig)
  : Promise<R> => {
    return axios.post(url, data, configWithCsrf(config))
  }

const get = axios.get

const deleteReq =
  <T = any, R = AxiosResponse<T>>
  (url: string, data?: any, config?: AxiosRequestConfig)
  : Promise<R> => {
    return axios.delete(url, configWithCsrf(config))
  }

const patch =
  <T = any, R = AxiosResponse<T>>
  (url: string, data?: any, config?: AxiosRequestConfig)
  : Promise<R> => {
    return axios.patch(url, data, configWithCsrf(config))
  }

const put =
  <T = any, R = AxiosResponse<T>>
  (url: string, data?: any, config?: AxiosRequestConfig)
  : Promise<R> => {
    return axios.put(url, data, configWithCsrf(config))
  }


export {
  buildUrl,

  post,
  get,
  deleteReq,
  patch,
  put,
}
